import React from 'react';
import { FormattedMessage } from 'react-intl';
import './MobileNav.scss';
import { ArrowLeft24, DotMark16 } from '@carbon/icons-react';
import data from '../../locales/en.json';

import { _setHome, _setCurrentScene } from '../../store/actionCreators';

import { useSelector, useDispatch } from 'react-redux';

import { CSSTransition } from 'react-transition-group';

const MobileNav = () => {
  const home = useSelector((state) => state.home);
  const currentScene = useSelector((state) => state.currentScene);
  const transitioning = useSelector((state) => state.transitioning);

  const dispatch = useDispatch();

  const setHome = (bool) => {
    dispatch(_setHome(bool));
  };
  const setCurrentScene = (num) => {
    dispatch(_setCurrentScene(num));
  };

  const handleClickHome = () => {
    if (!transitioning) {
      setHome(true);
      setCurrentScene(null);
    }
  };

  const handleClickScene = (i) => {
    if (!transitioning && i !== currentScene) {
      setHome(false);
      setCurrentScene(i);
    }
  };

  return (
    <div className="mobilenav-container">
      <div className="bx--grid">
        <div className="bx--row">
          <div className="bx--col">
            <div className="mobilenav">
              <CSSTransition
                in={!home}
                timeout={{ enter: 110, exit: 110 }}
                classNames="mobilenav-home-display"
                unmountOnExit>
                <button
                  className="home-btn body-short-01 white fast-02"
                  onClick={handleClickHome}>
                  <ArrowLeft24 />
                </button>
              </CSSTransition>

              <div className="scene-btn-group">
                {data.Content.scene.map((scene, i) => (
                  <button
                    className={`body-short-01 ${
                      i === currentScene ? 'white btn-on' : 'gray-50'
                    }`}
                    onClick={() => handleClickScene(i)}
                    key={i}>
                    <DotMark16 />
                    <FormattedMessage
                      id={`Content.scene.${i}.title`}
                      defaultMessage={scene.title}
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
